<!-- 
    常用号码
    jay 2020-02-28
 -->
<template>
  <div class="childRoute-wrapper">
    <van-nav-bar :fixed="true" left-arrow @click-left="navbarback">
      <van-field
        type="tel"
        class="search-input"
        @input="fieldInput"
        left-icon="search"
        v-model="searchPhone"
        slot="title"
        :placeholder="$t('common.enterMobile')"
      />
      <span slot="right" @click="addFlag = true">
        {{ $t("recharge.newlyAdded") }}
      </span>
    </van-nav-bar>
    <div class="scroll-wrapper">
      <div class="tag-box">
        <div class="my-tag">
          <div class="tag-list">
            <a
              :class="{ active: tagActive == index }"
              v-for="(item, index) in tagList"
              :key="index"
              @click="changeIndex(index)"
            >
              {{ item.tag_name }}
            </a>
          </div>
        </div>
        <a class="a-link" @click="tagManageFlag = true">
          {{ $t("recharge.labelManagement") }}
        </a>
      </div>
      <div
        class="tag-number"
        :class="{ noCrad: !showList.length && !getListFlag }"
      >
        <div v-if="!showList.length && !getListFlag" class="noCard-wrap">
          <img src="@/assets/images/public/pic_kong@2x.png" />
          <p class="text-gray">{{ $t("common.noData") }}</p>
        </div>
        <scroll
          v-if="showList.length"
          ref="scroll"
          class="tag-warrper"
          :data="showList"
        >
          <van-cell-group class="tag-num-list" :border="false">
            <van-cell
              :border="false"
              v-for="(item, index) in showList"
              :key="index"
              :title="item.name ? item.name : _phoneFormat(item.mobile)"
              @click="editItem(index)"
            />
          </van-cell-group>
        </scroll>
      </div>
    </div>

    <van-dialog
      v-model="addFlag"
      :title="$t('recharge.newNumber')"
      :confirmButtonText="$t('recharge.newlyAdded')"
      show-cancel-button
      :beforeClose="userMobilesAdd"
    >
      <van-cell-group :border="false" class="tag-input">
        <van-field
          :border="false"
          type="tel"
          v-model="mobile"
          @input="changeCellphone"
          :error="error.mobile ? true : false"
          :placeholder="$t('common.enterMobile')"
        />
      </van-cell-group>
    </van-dialog>

    <transition name="slide">
      <tag-manage
        v-if="tagManageFlag"
        :tagManageFlag.sync="tagManageFlag"
        :tagList="tagList"
        @changeTagList="changeTagList"
      ></tag-manage>
    </transition>

    <transition name="slide">
      <edit-mobile
        v-if="editMobileFlag"
        :editMobileFlag.sync="editMobileFlag"
        :tagList="tagList"
        :editInfo="editInfo"
        @changeMobile="changeMobile"
      ></edit-mobile>
    </transition>
  </div>
</template>

<script>
import * as validate from "@/commonJs/validate.js";
import TagManage from "@/components/recharge/tagManage";
import EditMobile from "@/components/recharge/editMobile";
export default {
  props: {
    tagList: {
      //标签列表
      type: Array,
      default: function() {
        return [];
      }
    },
    showTagFlag: {
      //显示隐藏
      type: Boolean,
      default: function() {
        return false;
      }
    }
  },
  components: {
    TagManage,
    EditMobile
  },
  data() {
    return {
      searchPhone: "",
      tagActive: 0,
      telList: [],
      showList: [],
      addFlag: false,
      mobile: "",

      error: {
        mobile: false
      },

      tagManageFlag: false, //标签管理
      editMobileFlag: false,
      editInfo: {},
      editIndex: -1,

      getListFlag: false
    };
  },
  created() {},
  mounted() {
    if (this.tagList.length) {
      this.userMobiles();
    }
  },
  computed: {},
  methods: {
    navbarback() {
      //返回上一页
      this.$emit("update:showTagFlag", false);
    },
    changeCellphone() {
      // 手机
      this.error.mobile = validate.validateMobile(this.mobile);
    },
    editItem(index) {
      //编辑号码,跳页
      let vm = this;
      console.log("editItem", vm.showList[index]);
      vm.editMobileFlag = true;
      vm.editIndex = index;
      vm.editInfo = vm.showList[index];
    },
    changeMobile() {
      //修改号码
      let vm = this;
      vm.userMobiles();
    },
    changeTagList(data) {
      //修改标签,包括编辑和删除
      let vm = this;
      let arr = JSON.parse(JSON.stringify(vm.tagList));
      if (data.type == 1) {
        //编辑标签
        arr[data.index].tag_name = data.tagName;
      } else {
        //删除标签
        arr.splice(data.index, 1);
        //标签删除时，判断当前标签是否有选中
        if (vm.tagActive == data.index) {
          //如果选中的和删除的相同
          if (data.index == vm.tagList.length - 1) {
            //如果删除的是最后一个,则删除完成之后，最后一个
            vm.tagNew = true;
          } else if (data.index == 0) {
            //如果删除的是第一个,则删除完成之后，还是显示第一个
            vm.tagActive = 0;
          } else {
            vm.tagActive = vm.tagActive - 1;
          }
        }
        if (vm.tagActive > data.index) {
          vm.tagActive = vm.tagActive - 1;
        }
        vm.userMobiles();
      }
      vm.$emit("update:tagList", arr);
    },
    fieldInput(value) {
      //搜索号码
      let vm = this;
      if (value == "") {
        return;
      }
      let tel = value.replace(/\s/g, "");
      let arr = [];
      for (let i = 0; i < vm.telList.length; i++) {
        if (vm.telList[i].mobile.indexOf(tel) != -1) {
          arr.push(vm.telList[i]);
        }
      }
      vm.showList = JSON.parse(JSON.stringify(arr));
      console.log("vm.showList", vm.showList);
    },
    changeIndex(index) {
      this.searchPhone = "";
      this.tagActive = index;
      this.userMobiles();
    },
    userMobilesAdd(action, done) {
      //新增手机号
      let vm = this;
      if (action === "confirm") {
        //编辑标签确认
        if (vm.mobile == "") {
          vm.$toast(vm.$t("common.enterMobile"));
          //弹窗不关闭
          done(false);
          return false;
        }

        if (vm.error.mobile) {
          // 手机号码报错
          vm.$toast(vm.error.mobile);
          //弹窗不关闭
          done(false);
          return false;
        }

        if (!vm.tagList.length) {
          vm.$toast(vm.$t("recharge.addLabelAfterNumber"));
          //弹窗关闭
          done(true);
          return false;
        }

        //先判断该标签中是否存在号码
        let index = -1;
        for (let i = 0; i < vm.telList.length; i++) {
          if (
            vm.telList[i].mobile.replace(/\s/g, "") ==
            vm.mobile.replace(/\s/g, "")
          ) {
            index = i;
          }
        }
        if (index != -1) {
          vm.$toast(vm.$t("recharge.labelAlreadyNumber"));
          //弹窗不关闭
          done(false);
          return false;
        }
        let params = {};
        params.tag = vm.tagList[vm.tagActive].id;
        params.mobile = vm.mobile.replace(/\s/g, "");
        // params.name = '';
        vm.$post("/app/user/userMobilesAdd", params, { alert: true }).then(
          res => {
            console.log("userMobilesAdd", res);
            vm.$toast(res.msg);
            if (res.code == 0) {
              vm.mobile = "";
              vm.userMobiles();
              //弹窗关闭
              done();
            } else {
              vm.$toast(res.msg);
              //弹窗不关闭
              done(false);
            }
          }
        );
      } else {
        //点击取消 弹窗关闭
        done();
      }
    },
    userMobiles() {
      //获取电话簿列表
      let vm = this;
      let params = {};
      params.tag = vm.tagList[vm.tagActive].id;
      vm.getListFlag = true;
      vm.showList = [];
      vm.$post("/app/user/userMobiles", params, { loading: true }).then(res => {
        console.log("userMobiles", res);
        vm.getListFlag = false;
        vm.telList = res.list;
        vm.showList = res.list;
      });
    }
  },
  watch: {
    addFlag(bol) {
      if (bol) {
        this.mobile = "";
        this.error.mobile = false;
      }
    }
  }
};
</script>

<style lang="less" scoped>
.tag-box {
  padding: 15px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  a.a-link {
    margin-left: 10px;
    color: #2042ab;
    text-decoration: underline;
  }
}
.tag-number {
  position: absolute;
  top: 52px;
  bottom: 0;
  left: 0;
  right: 0;
  background: #fff;
}
.van-nav-bar__title {
  max-width: initial;
  width: 248px;
  height: 100%;
  display: flex;
  align-items: center;
  margin: 0 auto;
}
.search-input {
  height: 32px;
  border-radius: 32px;
  background: #eff2f5;
  padding: 0 10px;
  display: flex;
  align-items: center;
}
.my-tag {
  flex-grow: 1;
  padding: 0;
  padding-bottom: 0;
  .tag-list {
    display: flex;
    flex-wrap: wrap;
    align-items: center;
    a {
      width: 64px;
      // width: auto;
      // max-width: 64px;
      // padding: 0 16px;
      height: 28px;
      border-radius: 28px;
      display: flex;
      align-items: center;
      justify-content: center;
      background: #eff2f5;
      color: #4a4a4a;
      font-size: 11px;
      margin-right: 1.1px;
      &.active {
        background: linear-gradient(
          90deg,
          rgba(32, 67, 172, 1) 0%,
          rgba(19, 15, 115, 1) 100%
        );
        color: #fff;
      }
    }
  }
}
.tag-num-list {
  padding: 0 15px;
  .van-cell {
    height: 40px;
    align-items: center;
    padding: 0;
    border-bottom: 1.1px solid #e4e4e4;
    font-size: 16px;
  }
}
.tag-input {
  padding: 22px;
  /deep/.van-cell {
    padding: 0 12px;
    height: 30px;
    background: #f0f2f5;
    border-radius: 3px;
    font-size: 16px;
    .van-field__body,
    .van-field__control {
      height: 100%;
    }
  }
}
</style>
